import { fetcher } from "helpers/fetcher";

import { TCreateFieldSalesTicketReq, TFieldSalesTicketRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createFieldSalesTicket = async (
  payload: TCreateFieldSalesTicketReq
) => {
  return await fetcher<
    TFieldSalesTicketRes,
    TCreateFieldSalesTicketReq["data"]
  >(ENDPOINT.MANAGEMENT.CREATE_FIELD_SALES_TICKET, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.CREATE_FIELD_SALES_TICKET.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
  });
};

export const mutationCreateFieldSalesTicket = async (
  payload: TCreateFieldSalesTicketReq
) => {
  return (await createFieldSalesTicket(payload)).data.message;
};

mutationCreateFieldSalesTicket._key = (payload: TCreateFieldSalesTicketReq) => [
  ENDPOINT.MANAGEMENT.CREATE_FIELD_SALES_TICKET.url,
  payload,
];
